import { Drawer as DrawerPrimitive } from "vaul";
import { ComponentProps, FC } from "react";
import { DrawerContent } from "./DrawerContent";
import { DrawerHeader } from "./DrawerHeader";
import { DrawerTitle } from "./DrawerTitle";
import { DrawerDescription } from "./DrawerDescription";
import { DrawerChildren } from "./DrawerChildren";
import { DrawerFooter } from "./DrawerFooter";
import { DrawerClose } from "./DrawerClose";
import { TDrawerRootProps, DRAWER_CONTAINER_CLASS } from "./Drawer.config";
import { Container, Flex } from "@/ui/components/layout";

export const Drawer: FC<TDrawerRootProps> = (
  {
    title,
    description,
    children,
    footer,
    actionsOrientation = "vertical",
    actionsPosition = "scrolling",
    shouldScaleBackground = false,
    onClose,
    onOpenChange,
    ...props
  },
) => (
  <DrawerPrimitive.Root
    direction="bottom"
    shouldScaleBackground={shouldScaleBackground}
    onOpenChange={(isOpen) => {
      onOpenChange?.(isOpen);

      if (!isOpen) {
        onClose?.();
      }
    }}
    // vaul's root props are a discriminated union (snapPoints/fadeFromIndex),
    // so the spread of our rest props needs a cast to satisfy it.
    {...(props as ComponentProps<typeof DrawerPrimitive.Root>)}
  >
    <DrawerContent {...(description ? {} : { "aria-describedby": undefined })}>
      <Container size="md" className={DRAWER_CONTAINER_CLASS}>
        <DrawerHeader>
          <Flex align="center" justify="between" gap="4" className="w-full">
            <DrawerTitle>{ title }</DrawerTitle>
            <DrawerClose />
          </Flex>
          { description ? (
            <DrawerDescription>{ description }</DrawerDescription>
          ) : null }
        </DrawerHeader>
        <DrawerChildren>
          { children }
          { actionsPosition === "scrolling" ? (
            <DrawerFooter
              {...footer}
              actionsOrientation={actionsOrientation}
              actionsPosition={actionsPosition}
            />
          ) : null }
        </DrawerChildren>
      </Container>
      { actionsPosition === "fixed" ? (
        <DrawerFooter
          {...footer}
          actionsOrientation={actionsOrientation}
          actionsPosition={actionsPosition}
        />
      ) : null }
    </DrawerContent>
  </DrawerPrimitive.Root>
);

Drawer.displayName = "Drawer";
